module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logoSJD_navbar-1b710f8cac711c7a09e68fcb6111319a.jpeg";